import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
// import

const tokenSlice = createSlice({
   name: 'token',
   initialState: '' as string,
   reducers: {
      addToken(state, action: PayloadAction<string>) {
         return action.payload;
      },
      removeToken(state, action) {
         return '';
      }
   }
});

export const { addToken, removeToken } = tokenSlice.actions;
export const getTokenSelector = (state: RootState) => state.token;
export const getIsToken = (state: RootState) => state.token.length > 1;
export default tokenSlice.reducer;
